import { useContext } from "react"
import { EmpresasContext } from "../contexts/EmpresasContext"

export function useEmpresas() {
  const value = useContext(EmpresasContext)

  return value
}